module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/usuario-temporario/usuario-temporario.component.scss
// module id = ./src/app/shared/componentes/usuario-temporario/usuario-temporario.component.scss
// module chunks = main